import { computed, defineComponent, ref, getCurrentInstance } from "vue";
import { ElSchemaFormFieldset } from "el-schema-form";
import { TransformType } from "@/store/creative/model-editor/index.type";
import FormPanel from "@/views/creative/components/form-panel.vue";
import ResetResource from "@/views/creative/components/reset-resource.vue";
import { useModelStore } from "@/views/creative/model-editor/model-mixin";
import { PtButtonType, PtButtonTheme, PtButtonSize } from "@com/pt-components/pt-button/enum";
export default defineComponent({
    components: {
        ResetResource: ResetResource,
        ElSchemaFormFieldset: ElSchemaFormFieldset,
        FormPanel: FormPanel
    },
    setup: function setup(props) {
        var handleResetTranslate = function handleResetTranslate() {
            var translateValue = [
                0,
                0,
                0
            ];
            if (currentResetModel.value) {
                translateValue = [
                    currentResetModel.value[0],
                    currentResetModel.value[1],
                    currentResetModel.value[2], 
                ];
            }
            basicModel.value.translateX = translateValue[0];
            basicModel.value.translateY = translateValue[1];
            basicModel.value.translateZ = translateValue[2];
        };
        var handleResetRotate = function handleResetRotate() {
            var rotateValue = [
                0,
                0,
                0
            ];
            if (currentResetModel.value) {
                rotateValue = [
                    currentResetModel.value[3],
                    currentResetModel.value[4],
                    currentResetModel.value[5], 
                ];
            }
            basicModel.value.rotateX = rotateValue[0];
            basicModel.value.rotateY = rotateValue[1];
            basicModel.value.rotateZ = rotateValue[2];
        };
        var handleResetScale = function handleResetScale() {
            var scaleValue = [
                1,
                1,
                1
            ];
            if (currentResetModel.value) {
                scaleValue = [
                    currentResetModel.value[6],
                    currentResetModel.value[7],
                    currentResetModel.value[8], 
                ];
            }
            basicModel.value.scaleX = scaleValue[0];
            basicModel.value.scaleY = scaleValue[1];
            basicModel.value.scaleZ = scaleValue[2];
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var store = root.$store;
        var modelId = useModelStore(store).modelId;
        var scaleLink = ref(true);
        var basicModel = computed({
            get: function get() {
                return store.state.creative.modelEditor.basicModel;
            },
            set: function set(val) {
                store.commit("creative/modelEditor/setBasicModel", val);
            }
        });
        var resetModel = computed(function() {
            return store.state.creative.modelEditor.resetModel;
        });
        var currentResetModel = computed(function() {
            return resetModel.value[JSON.stringify(modelId.value)];
        });
        var handleClickLink = function() {
            console.log("handleClickLink");
            scaleLink.value = !scaleLink.value;
        };
        var basicFormItemList = [
            {
                prop: "translateX",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.translateX = value;
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 0.1,
                    min: -100,
                    max: 100,
                    stepStrictly: true
                },
                label: "X"
            },
            {
                prop: "translateY",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.translateY = value;
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 0.1,
                    min: -100,
                    max: 100,
                    stepStrictly: true
                },
                label: "Y"
            },
            {
                prop: "translateZ",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.translateZ = value;
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 0.1,
                    min: -100,
                    max: 100,
                    stepStrictly: true
                },
                label: "Z"
            },
            {
                prop: "rotateX",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.rotateX = value;
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 1,
                    min: -360,
                    max: 360,
                    stepStrictly: true
                },
                label: "X"
            },
            {
                prop: "rotateY",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.rotateY = value;
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 1,
                    min: -360,
                    max: 360,
                    stepStrictly: true
                },
                label: "Y"
            },
            {
                prop: "rotateZ",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.rotateZ = value;
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 1,
                    min: -360,
                    max: 360,
                    stepStrictly: true
                },
                label: "Z"
            },
            {
                prop: "scaleX",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.scaleX = value;
                            if (scaleLink.value) {
                                basicModel.value.scaleY = value;
                                basicModel.value.scaleZ = value;
                            }
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 0.1,
                    min: -100,
                    max: 100,
                    stepStrictly: true
                },
                label: "X"
            },
            {
                prop: "scaleY",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.scaleY = value;
                            if (scaleLink.value) {
                                basicModel.value.scaleX = value;
                                basicModel.value.scaleZ = value;
                            }
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 0.1,
                    min: -100,
                    max: 100,
                    stepStrictly: true
                },
                label: "Y"
            },
            {
                prop: "scaleZ",
                component: "input-number",
                class: "custom-number-form-item",
                field: {
                    listeners: {
                        change: function(value) {
                            basicModel.value.scaleZ = value;
                            if (scaleLink.value) {
                                basicModel.value.scaleX = value;
                                basicModel.value.scaleY = value;
                            }
                        }
                    },
                    controls: false,
                    scrub: true,
                    step: 0.1,
                    min: -100,
                    max: 100,
                    stepStrictly: true
                },
                label: "Z"
            }, 
        ];
        var basicTranslateFormItemList = computed(function() {
            return basicFormItemList.filter(function(item) {
                return item.prop.includes("translate");
            });
        });
        var basicRotationFormItemList = computed(function() {
            return basicFormItemList.filter(function(item) {
                return item.prop.includes("rotate");
            });
        });
        var basicScaleFormItemList = computed(function() {
            return basicFormItemList.filter(function(item) {
                return item.prop.includes("scale");
            });
        });
        return {
            handleResetTranslate: handleResetTranslate,
            handleResetScale: handleResetScale,
            handleResetRotate: handleResetRotate,
            basicTranslateFormItemList: basicTranslateFormItemList,
            basicRotationFormItemList: basicRotationFormItemList,
            basicScaleFormItemList: basicScaleFormItemList,
            basicModel: basicModel,
            TransformType: TransformType,
            PtButtonType: PtButtonType,
            PtButtonTheme: PtButtonTheme,
            PtButtonSize: PtButtonSize,
            handleClickLink: handleClickLink,
            scaleLink: scaleLink
        };
    }
});
